const en = {
  systemInfo: {
    header: 'System Information',
    content: {
      casmonVersion: "CAS MON GO Version",
      branch: "Branch",
      commitId: "Commit ID",
      commitDate: "Commit Date",
      ciBuildDate: "CI Build Date",
      databaseVersion: "Database Version"
    },
    dbUpdateRecommended: 'Database update recommended'
  }
};

const de = {
  systemInfo: {
    header: 'System-Informationen',
    content: {
      casmonVersion: "CAS MON GO Version",
      branch: "Branch",
      commitId: "Commit ID",
      commitDate: "Commit Datum",
      ciBuildDate: "CI Build Datum",
      databaseVersion: "Datenbankversion"
    },
    dbUpdateRecommended: 'Update der Datenbank empfohlen'
  }
};

export default {
  en,de
};
